import { createSlice } from '@reduxjs/toolkit';

const RegionEditslice = createSlice({
  name: 'RegionEditslice',
  initialState: {
    isLoading: false,
    getRegionData: [],
    isError: null,
    isAddLoading: false,
    // Local language options, served by the backend so the admin app
    // keeps no language list of its own.
    invoiceLanguageOptions: [],
  },
  reducers: {
    ////////// get region data /////////
    requestGetRegion: (state) => {
      return { ...state, isLoading: true };
    },
    responseGetRegion: (state, action) => {
      return {
        ...state,
        isLoading: false,
        getRegionData: action.payload,
        isEditLoading: false,
      };
    },
    failureGetRegion: (state, action) => {
      return { ...state, isLoading: false, isError: action?.payload };
    },

    ///////////////// get invoice language options /////////////////
    responseGetInvoiceLanguages: (state, action) => {
      return { ...state, invoiceLanguageOptions: action.payload ?? [] };
    },

    ///////////////// update region tax /////////////////
    requestUpdateRegionTax: (state) => {
      return { ...state, isEditLoading: true };
    },
    responseUpdateRegionTax: (state) => {
      return { ...state, isEditLoading: false };
    },
    failureUpdateRegionTax: (state, action) => {
      return { ...state, isEditLoading: false, isError: action?.payload };
    },

    ///////////////// add region /////////////////
    requestAddRegion: (state) => {
      return { ...state, isAddLoading: true };
    },
    responseAddRegion: (state) => {
      return { ...state, isAddLoading: false };
    },
    failureAddRegion: (state, action) => {
      return { ...state, isAddLoading: false, isError: action?.payload };
    },
  },
});

export const {
  responseGetInvoiceLanguages,
  failureGetRegion,
  requestGetRegion,
  responseGetRegion,
  failureUpdateRegionTax,
  requestUpdateRegionTax,
  responseUpdateRegionTax,
  requestAddRegion,
  responseAddRegion,
  failureAddRegion,
} = RegionEditslice.actions;
export default RegionEditslice.reducer;
